import Vue from "vue";
import VueRouter from "vue-router";
import moment from 'moment';

Vue.use(VueRouter);

function loadView(startDateTime, endDateTime){
  const now = moment();
  const start = moment(startDateTime, 'YYYY-MM-DD HH:mm');
  if(endDateTime){
    var end = moment(endDateTime, 'YYYY-MM-DD HH:mm');
  }
  if(now.isSameOrAfter(start)){
    if(endDateTime){
      if(now.isSameOrAfter(end)){
        return () => import('@/views/default/event/_august2025.vue')
      }else{
        return () => import('@/views/default/event/_sep2025.vue')
      }
    }else{
      return () => import('@/views/default/event/_sep2025.vue')
    }
  }else{
    return () => import('@/views/default/event/_august2025.vue')
  }
}

const routes = [
  // {
  //   path: "",
  //   component: () => import("@/views/default/index.vue"),
  //   children: [
  {
    path: "",
    component: () => import("@/views/default/index.vue"),
    children: [
      {
        path: "",
        name: "home",
        // component: () => import("@/views/default/_rightBar.vue")
        component: () => import("@/views/default/_hotgame.vue")
      },
      // {
      //   path: "/forgotPassword",
      //   component: () => import("@/views/default/_forgotPassword.vue"),
      //   meta: { beforeLogIn: true}
      // },
      // {
      //   path: "/epic",
      //   name: "epic",
      //   component: () => import("@/views/default/_rightBar.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/epic"
      //     }
      //   ]
      // },
      // {
      //   path: "/hot",
      //   name: "hot",
      //   component: () => import("@/views/default/_hotgame.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/hot"
      //     }
      //   ]
      // },
      {
        path: "/slot",
        name: "slot",
        component: () => import("@/views/default/_slot.vue"),
        children: [
          {
            path: "*",
            redirect: "/slot"
          }
        ]
      },
      {
        path: "/hash",
        name: "hash",
        component: () => import("@/views/default/_hash.vue"),
        children: [
          {
            path: "*",
            redirect: "/hash"
          }
        ]
      },
      // {
      //   path: "/egames",
      //   name: "egames",
      //   component: () => import("@/views/default/_egames.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/egames"
      //     }
      //   ]
      // },
      {
        path: "/casino",
        component: () => import("@/views/default/_casino.vue"),
        children: [
          {
            path: "*",
            redirect: "/casino"
          }
        ]
      },
      {
        path: "/table",
        component: () => import("@/views/default/_table.vue"),
        children: [
          {
            path: "*",
            redirect: "/table"
          }
        ]
      },
      {
        path: "/fishing",
        component: () => import("@/views/default/_fishing.vue"),
        children: [
          {
            path: "*",
            redirect: "/fishing"
          }
        ]
      },
      {
        path: "/bingo",
        component: () => import("@/views/default/_bingo.vue"),
        children: [
          {
            path: "*",
            redirect: "/bingo"
          }
        ]
      },
      {
        path: "/event",
        // component: () => import("@/views/default/event/_july2025.vue"),
        component: loadView('2025-09-01 00:00'),
        children: [
          {
            path: "*",
            redirect: "/event"
          }
        ]
      },
      // {
      //   path: "/sportbook",
      //   component: () => import("@/views/default/_sportbook.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/sportbook"
      //     }
      //   ]
      // },
      // {
      // {
      //   path: "/sabong",
      //   component: () => import("@/views/default/_sabong.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/sabong"
      //     }
      //   ]
      // },
      // {
      //   path: "/profile",
      //   name: "profile",
      //   component: () => import("@/views/default/_newProfile.vue"),
      //   meta: { requiredLoggedIn: true},
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/profile"
      //     }
      //   ]
      // },
      {
        path: "/setting",
        name: "setting",
        component: () => import("@/views/default/_memberProfile.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/setting"
          }
        ]
      },
      {
        path: "/deposit",
        name: "deposit",
        component: () => import("@/views/default/_deposit.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/deposit"
          }
        ]
      },
      {
        path: "/withdrawal",
        name: "withdrawal",
        component: () => import("@/views/default/_withdrawal.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/withdrawal"
          }
        ]
      },
      {
        path: "/return",
        component: () => import("@/views/default/_return.vue"),
        // redirect: to =>{
        //   return { path: '/statement', query: { q: 'history' }}
        // },
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/return"
          }
        ]
      },
      {
        path: "/statement",
        name: "statement",
        component: () => import("@/views/default/_statement.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/statement"
          }
        ]
      },
      {
        path: "/contactUs",
        component: () => import("@/views/default/_contactUs.vue"),
        children: [
          {
            path: "*",
            redirect: "/contactUs"
          }
        ]
      },
      {
        path: "/partners",
        component: () => import("@/views/default/_partnership.vue"),
        children: [
          {
            path: "*",
            redirect: "/partners"
          }
        ]
      },
      {
        path: "/news",
        component: () => import("@/views/default/_news.vue"),
        children: [
          {
            path: "*",
            redirect: "/news"
          }
        ]
      },
      {
        path: "/review",
        component: () => import("@/views/default/_review.vue"),
        children: [
          {
            path: "*",
            redirect: "/review"
          }
        ]
      },
      {
        path: "/freeplay",
        component: () => import("@/views/default/_freePlay.vue"),
      },
      {
        path: "/how-to-make-the-most-of-the-slot-free-100-pesos-bonus-at-epicwin-philippines",
        component: () => import("@/views/default/news/_article5.vue"),
        children: [
          {
            path: "*",
            redirect: "/how-to-make-the-most-of-the-slot-free-100-pesos-bonus-at-epicwin-philippines"
          }
        ]
      },
      {
        path: "/new-member-enjoy-a-100-free-bonus-casino-no-deposit-philippines-at-EpicWin",
        component: () => import("@/views/default/news/_article6.vue"),
        children: [
          {
            path: "*",
            redirect: "/new-member-enjoy-a-100-free-bonus-casino-no-deposit-philippines-at-EpicWin"
          }
        ]
      },
      {
        path: "/gcash-goldmine-how-to-score-a-slot-free-100-bonus-at-epicwin-philippines",
        component: () => import("@/views/default/news/_article7.vue"),
        children: [
          {
            path: "*",
            redirect: "/gcash-goldmine-how-to-score-a-slot-free-100-bonus-at-epicwin-philippines"
          }
        ]
      },
      {
        path: "/play-legit-casino-games-when-you-are-a-new-member-register-free-100",
        component: () => import("@/views/default/news/_article8.vue"),
        children: [
          {
            path: "*",
            redirect: "/play-legit-casino-games-when-you-are-a-new-member-register-free-100"
          }
        ]
      },
      {
        path: "/cash-in-on-fun-your-guide-to-the-best-online-casino-philippines",
        component: () => import("@/views/default/news/_article9.vue"),
        children: [
          {
            path: "*",
            redirect: "/cash-in-on-fun-your-guide-to-the-best-online-casino-philippines"
          }
        ]
      },
      {
        path: "/online-casino-epicwin-philippines-is-providing-slot-free-100-pesos-to-all-new-registered-players",
        component: () => import("@/views/default/news/_article10.vue"),
        children: [
          {
            path: "*",
            redirect: "/online-casino-epicwin-philippines-is-providing-slot-free-100-pesos-to-all-new-registered-players"
          }
        ]
      },
      {
        path: "/why-try-your-luck-in-epicwin-casino-online",
        component: () => import("@/views/default/news/_luck.vue"),
        children: [
          {
            path: "*",
            redirect: "/why-try-your-luck-in-epicwin-casino-online"
          }
        ]
      },
      {
        path: "/understanding-in-detail-about-epicwin-slot",
        component: () => import("@/views/default/news/_detail.vue"),
        children: [
          {
            path: "*",
            redirect: "/understanding-in-detail-about-epicwin-slot"
          }
        ]
      },
      {
        path: "/jili-slot-review-top-features-and-why-players-love-it",
        component: () => import("@/views/default/news/_jili-slot-review-top-features-and-why-players-love-it.vue"),
        children: [
          {
            path: "*",
            redirect: "/jili-slot-review-top-features-and-why-players-love-it"
          }
        ]
      },
      {
        path: "/best-jili-slots-to-play-in-2025-rtp-bonuses-gameplay",
        component: () => import("@/views/default/news/_best-jili-slots-to-play-in-2025-rtp-bonuses-gameplay.vue"),
        children: [
          {
            path: "*",
            redirect: "/best-jili-slots-to-play-in-2025-rtp-bonuses-gameplay"
          }
        ]
      },
      {
        path: "/top-online-casino-payment-methods-in-the-philippines",
        component: () => import("@/views/default/news/_topCasinopaymentph.vue"),
        children: [
          {
            path: "*",
            redirect: "/top-online-casino-payment-methods-in-the-philippines"
          }
        ]
      },
      {
        path: "/live-dealer-games-in-online-casinos-philippines-the-future-of-gambling",
        component: () => import("@/views/default/news/_liveDealer.vue"),
        children: [
          {
            path: "*",
            redirect: "/live-dealer-games-in-online-casinos-philippines-the-future-of-gambling"
          }
        ]
      },
      {
        path: "/how-to-win-big-on-jili-slots",
        component: () => import("@/views/default/news/_how-to-win-big-on-jili-slots.vue"),
        children: [
          {
            path: "*",
            redirect: "/how-to-win-big-on-jili-slots"
          }
        ]
      },
      {
        path: "/jili-slots-vs-other-slot-providers",
        component: () => import("@/views/default/news/_jili-slots-vs-other-slot-providers.vue"),
        children: [
          {
            path: "*",
            redirect: "/jili-slots-vs-other-slot-providers"
          }
        ]
      },
      {
        path: "/game-selection-bonuses-and-features",
        component: () => import("@/views/default/news/_game-selection.vue"),
        children: [
          {
            path: "*",
            redirect: "/game-selection-bonuses-and-features"
          }
        ]
      },
      {
        path: "/beginner-guide-jili-casino",
        component: () => import("@/views/default/news/_beginner-guide.vue"),
        children: [
          {
            path: "*",
            redirect: "/beginner-guide-jili-casino"
          }
        ]
      },
      {
        path: "/game-changer-in-mobile-gaming",
        component: () => import("@/views/default/news/_gameChanger.vue"),
        children: [
          {
            path: "*",
            redirect: "/game-changer-in-mobile-gaming"
          }
        ]
      },
      {
        path: "/why-epicwin-slots-are-going-viral-in-2025",
        component: () => import("@/views/default/news/_whyViral.vue"),
        children: [
          {
            path: "*",
            redirect: "/why-epicwin-slots-are-going-viral-in-2025"
          }
        ]
      },
      {
        path: "/top-jili-casino-games-2025",
        component: () => import("@/views/default/news/_topJili.vue"),
        children: [
          {
            path: "*",
            redirect: "/top-jili-casino-games-2025"
          }
        ]
      },
      {
        path: "/jili-revolutionizing-online-gambling-industry",
        component: () => import("@/views/default/news/_revolution.vue"),
        children: [
          {
            path: "*",
            redirect: "/jili-revolutionizing-online-gambling-industry"
          }
        ]
      },
      // {
      //   path: "/aboutUs",
      //   component: () => import("@/views/default/_aboutUs.vue")
      // },
      // {
      //   path: "/faq",
      //   component: () => import("@/views/default/_faq.vue")
      // },
      {
        path: "/promotions",
        name: "promotions",
        component: () => import("@/views/default/_promotions.vue"),
        children: [
          {
            path: "*",
            redirect: "/promotions"
          }
        ]
      },
      // {
      //   path: "/affiliate",
      //   component: () => import("@/views/default/_affiliate.vue")
      // },
      // {
      //   path: "/livestream",
      //   component: () => import("@/views/default/_livestream.vue"),
      //   children: [
      //     {
      //       path: "*",
      //       redirect: "/livestream"
      //     }
      //   ]
      // },
      {
        path: "/ambassador",
        component: () => import("@/views/default/_ambassador.vue"),
        children: [
          {
            path: "*",
            redirect: "/ambassador"
          }
        ]
      },
      {
        path: "/referral",
        name: "referral",
        component: () => import("@/views/default/_referral.vue"),
        // meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/referral"
          }
        ]
      },
      {
        path: "/inbox",
        name: "inbox",
        component: () => import("@/views/default/_inbox.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/inbox"
          }
        ]
      },
      {
        path: "/vip",
        name: "vip",
        component: () => import("@/views/default/_vip.vue"),
        meta: { requiredLoggedIn: true},
        children: [
          {
            path: "*",
            redirect: "/vip"
          }
        ]
      },
    ]
  },
  {
    path: "/mayapay",
    component: () => import("@/views/default/_mayaPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/htpay",
    component: () => import("@/views/default/_htPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/aipay",
    component: () => import("@/views/default/_aipay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/rmpay",
    component: () => import("@/views/default/_rmpay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/gopaygcash",
    component: () => import("@/views/default/payment/_gopayGcash.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/gopaymaya",
    component: () => import("@/views/default/payment/_gopayMaya.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/dgpaygcash",
    component: () => import("@/views/default/payment/_dgpayGcash.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/dgpaygcashqr",
    component: () => import("@/views/default/payment/_dgpayGcashqr.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/dgpaymaya",
    component: () => import("@/views/default/payment/_dgpayMaya.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/cloudpay",
    component: () => import("@/views/default/payment/_cloudPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/toppay",
    component: () => import("@/views/default/payment/_topPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/anfu",
    component: () => import("@/views/default/payment/_anfu.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/shunfapay",
    component: () => import("@/views/default/payment/_shunfaPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/worldpay",
    component: () => import("@/views/default/payment/_worldPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/rgpay",
    component: () => import("@/views/default/payment/_rgPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/wcpay",
    component: () => import("@/views/default/payment/_wcPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/goldpay",
    component: () => import("@/views/default/payment/_goldPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/xftgcash",
    component: () => import("@/views/default/payment/_xftgCash.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/xftusdt",
    component: () => import("@/views/default/payment/_xftUsdt.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/masayapay",
    component: () => import("@/views/default/payment/_masayaPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/xypay",
    component: () => import("@/views/default/payment/_xyPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/tygpay",
    component: () => import("@/views/default/payment/_tygPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/ctpay",
    component: () => import("@/views/default/payment/_ctPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/innpay",
    component: () => import("@/views/default/payment/_innPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/rkpay",
    component: () => import("@/views/default/payment/_rkPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/ezpay",
    component: () => import("@/views/default/payment/_ezPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/sgpay",
    component: () => import("@/views/default/payment/_sgPay.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/goldpay2",
    component: () => import("@/views/default/payment/_goldPay2.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/rkpaygcash",
    component: () => import("@/views/default/payment/_rkPaygcash.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/rkpaygcashqr",
    component: () => import("@/views/default/payment/_rkPaygcashQr.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/swpaygcash",
    component: () => import("@/views/default/payment/_swPaygcash.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/swpaygcashqr",
    component: () => import("@/views/default/payment/_swPaygcashQr.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/launchOne",
    component: () => import("@/views/default/oneapi/_launchGame.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/launchYgr",
    component: () => import("@/views/default/gameapi/_launchYgr.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/launchWow",
    component: () => import("@/views/default/gameapi/_launchWow.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/launchTbl",
    component: () => import("@/views/default/gameapi/_launchTbl.vue"),
    meta: { requiredLoggedIn: true}
  },
  {
    path: "/launchWbet",
    component: () => import("@/views/default/_launchWbet.vue"),
    meta: { requiredLoggedIn: true}
  },
  // {
  //   path: "/launchds88",
  //   component: () => import("@/views/default/sabong/_launchds88.vue"),
  //   meta: { requiredLoggedIn: true}
  // },
  // {
  //   path: "/launchIronclaw",
  //   component: () => import("@/views/default/sabong/_launchIronclaw.vue"),
  //   meta: { requiredLoggedIn: true}
  // },
  {
    path: "*",
    component: () => import("@/views/default/_errorPage.vue")
  },
  //   ]
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
